module.exports = __webpack_public_path__ + "cd2901bba42b1f8554330207bcd11ae4.woff";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/proxima-nova/2E6388_2_0.woff
// module id = 535
// module chunks = 0